'use client';

import { c as _c } from "react/compiler-runtime";
import type { ConnectEvent, MoonPayWebProvider } from '@morfi/onramp-sdk/web';
import { useTranslations } from 'next-intl';
import { type ReactNode, useEffect, useEffectEvent, useRef, useState } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { logger } from '@/lib/telemetry/logger';
export function FundingHostedVerification(t0) {
  const $ = _c(20);
  const {
    provider,
    onRefresh
  } = t0;
  const t = useTranslations("onramp");
  const container = useRef(null);
  const [attempt, setAttempt] = useState(0);
  const [failed, setFailed] = useState(false);
  const refresh = useEffectEvent(onRefresh);
  let t1;
  if ($[0] !== attempt || $[1] !== provider || $[2] !== refresh) {
    t1 = () => {
      const host = container.current;
      if (!attempt || !host) {
        return;
      }
      const owned = document.createElement("div");
      owned.className = "h-full w-full";
      host.append(owned);
      let active = true;
      let frame = null;
      const fail = function fail() {
        if (!active) {
          return;
        }
        setFailed(true);
        logger.warn("onramp.hosted_verification_failed");
      };
      provider.connect({
        container: owned,
        onEvent: event => {
          if (!active) {
            return;
          }
          if (event.kind === "error") {
            fail();
          }
          if (event.kind === "complete") {
            refresh().then(ok => {
              if (!ok) {
                fail();
              }
            }).catch(fail);
          }
        }
      }).then(result => {
        if (!result.ok) {
          fail();
        } else {
          if (active) {
            frame = result.value;
          } else {
            result.value.dispose();
          }
        }
      }).catch(fail);
      return () => {
        active = false;
        owned.remove();
        frame?.dispose();
      };
    };
    $[0] = attempt;
    $[1] = provider;
    $[2] = refresh;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== attempt || $[5] !== provider) {
    t2 = [provider, attempt];
    $[4] = attempt;
    $[5] = provider;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== attempt) {
    t3 = attempt > 0 && <div className="h-[28rem]" ref={container} />;
    $[7] = attempt;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== failed || $[10] !== t) {
    t4 = failed && <p role="alert">{t("kyc_challenge_retry")}</p>;
    $[9] = failed;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== attempt || $[13] !== failed || $[14] !== t) {
    t5 = (!attempt || failed) && <>{!attempt && <p className="text-body text-foreground-secondary">{t("kyc_additional_step")}</p>}<AnimatedButton onClick={() => {
        setFailed(false);
        setAttempt(_temp);
      }}>{failed ? t("retry") : t("continue_with_moonpay")}</AnimatedButton></>;
    $[12] = attempt;
    $[13] = failed;
    $[14] = t;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <div className="rr-block flex flex-col gap-3" data-private="true">{t3}{t4}{t5}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
function _temp(value) {
  return value + 1;
}